import { getBulkData } from './getBulkData'
import { getData } from './getData'

export const TypeTicketCollectionActions = {
  getData,
  getBulkData,
}
